var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logout"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 23.9375H14.0625C14.4768 23.937 14.8739 23.7723 15.1668 23.4793C15.4598 23.1864 15.6245 22.7893 15.625 22.375V20.0312H14.0625V22.375H4.6875V3.625H14.0625V5.96875H15.625V3.625C15.6245 3.21075 15.4598 2.81359 15.1668 2.52067C14.8739 2.22775 14.4768 2.06298 14.0625 2.0625H4.6875C4.27325 2.06298 3.87609 2.22775 3.58317 2.52067C3.29025 2.81359 3.12548 3.21075 3.125 3.625V22.375C3.12548 22.7893 3.29025 23.1864 3.58317 23.4793C3.87609 23.7723 4.27325 23.937 4.6875 23.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0828 16.5828L18.8844 13.7812H7.8125V12.2188H18.8844L16.0828 9.41719L17.1875 8.3125L21.875 13L17.1875 17.6875L16.0828 16.5828Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1baac44cca01f0ccecf3829d3552ac74.svg";
export { ForwardRef as ReactComponent };